import './styles.scss'

const English = ({ onClick }) => {
  let languageClass = 'language-item-en'

  return (
    <div className={languageClass}>
      <button onClick={() => onClick()}></button>
    </div>
  )
}

export default English
